export default "__VITE_ASSET__DyxMjma2__"